var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSantander(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "santander") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bt_peq_santander",
    transform: "translate(-19.000000, -4.000000)",
    fill: "#EC0000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9007351,11.7866201 C31.873888,11.1740128 31.7011799,10.5662836 31.3817717,10.0169716 L28.5635487,5.17155635 C28.3486523,4.80201699 28.2001545,4.40606497 28.1176956,4 L28,4.2024971 C27.3024557,5.40177484 27.3024557,6.87933737 27.9998801,8.07861512 L30.2544346,11.955209 C30.9519789,13.1544868 30.9519789,14.6321683 30.2544346,15.831565 L30.1366191,16.0340621 C30.0542801,15.6279971 29.9057822,15.2320451 29.6908858,14.8625058 L27.6268977,11.3136906 L26.3089943,9.04779335 C26.0940979,8.67825399 25.9457199,8.28230198 25.8632611,7.87635598 L25.7454456,8.07885307 C25.0502983,9.27408563 25.0481409,10.7456994 25.738614,11.9428355 L25.7383743,11.9429545 L28,15.831565 C28.6975443,17.0308428 28.6975443,18.5085243 28,19.707921 L27.8821845,19.9104181 C27.7997257,19.5043531 27.6512278,19.1084011 27.4363314,18.7388617 L24.6182283,13.8933275 C24.240212,13.2434808 24.0675039,12.5118976 24.099145,11.787215 C21.0822058,12.5696009 19,14.2309813 19,16.1545848 C19,18.8305922 23.0294572,21 28,21 C32.9705428,21 37,18.8305922 37,16.1545848 C37,14.2308624 34.9177942,12.5690061 31.9007351,11.7866201",
    id: "santander"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantander);
export default __webpack_public_path__ + "static/media/santander.05054a538e882d6aa8b6d14da1a31464.svg";
export { ForwardRef as ReactComponent };